import React, { useEffect, useState } from "react";
// lottie
import Lottie from "lottie-react";
// @Mui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  Typography,
} from "@mui/material";
// animations
import serverMaintenanceAnimation from "src/assets/animations/server-maintenance.json";

//  -------------------------------------------------------------------------------

function MaintenancePopUp() {
  const [open, setOpen] = useState(false);

  // useEffect(() => {
  //   // Check if the popup has been shown before
  //   const hasShownPopup = localStorage.getItem("hasShownPopup");

  //   if (!hasShownPopup) {
  //     setOpen(true);
  //     localStorage.setItem("hasShownPopup", "true");
  //   }
  // }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogContent>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Lottie animationData={serverMaintenanceAnimation} loop autoPlay />
          </Grid>
          <Grid item xs={12}>
            <Typography textAlign="center" variant="h4">
              Our Servers Are Resting Now!
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography textAlign="center" variant="body1">
              We are currently working on updates so we are sorry for any
              unstable experiences.
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={handleClose}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MaintenancePopUp;
